const DesktopSearchNearbyCard = ({ nearbyOnly, setNearbyOnly }) => (
  <div className="flex items-center justify-between gap-5 border-b border-black/10 pb-5 dark:border-white/10">
    <div className="min-w-0">
      <div className="text-[16px] font-semibold leading-5">내 주변만 보기</div>
      <div className="mt-1 truncate text-[12px] font-medium text-black/45 dark:text-white/45">
        현재 위치 주변의 장소만 표시합니다
      </div>
    </div>
    <button
      type="button"
      aria-pressed={nearbyOnly}
      className={`relative h-8 w-[52px] shrink-0 rounded-full transition ${
        nearbyOnly ? "bg-red" : "bg-black/12 dark:bg-white/20"
      }`}
      onClick={() => setNearbyOnly(!nearbyOnly)}
    >
      <span
        className={`absolute top-1 h-6 w-6 rounded-full bg-white shadow transition ${
          nearbyOnly ? "left-[24px]" : "left-1"
        }`}
      />
    </button>
  </div>
);

export default DesktopSearchNearbyCard;
